import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appCapitalizeWords]',
    standalone: true, // Important for standalone use
})
export class CapitalizeWordsDirective {
    private isProcessing = false; // Flag to prevent infinite loop

    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('input', ['$event']) onInput(event: Event): void {
        if (this.isProcessing) {
            return; // Prevent re-entry if already processing
        }

        this.isProcessing = true; // Set the flag to true

        const input = this.el.nativeElement;
        const cursorPos = input.selectionStart; // Keep cursor position

        const capitalized = input.value
            .split(' ')
            .map(word => (word ? word[0].toUpperCase() + word.slice(1) : ''))
            .join(' ');

        input.value = capitalized;
        input.setSelectionRange(cursorPos, cursorPos); // Restore cursor position

        this.isProcessing = false; // Reset the flag
    }
}